const QUERY_KEYS = {
  matching: "matching",
  matchingMe: "matchingMe",
  exposed: "exposed",
  hospitalMe: "HospitalMe",
  city: "city",
  district: "district",
  postDetail: "postDetail",
  hospitalDetail: "hospitalDetail",
  hospitalChannelDetail: "hospitalChannelDetail",
  reviewList: "reviewList",
  hospitalIbs: "hospitalIbs",
  hospitalIbsSearch: "hospitalIbsSearch",
  ibsCompare: "ibsCompare",
  tabs: "tabs",
  notifications: "notifications",
  notificationCount: "notificationCount",
  hospitalSearch: "hospitalSearch",
  hospitalList: "hospitalList",
  membership: "membership",
  user: "user",
  recentReviews: "recentReviews",
} as const;

export default QUERY_KEYS;
